import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'flex justify-center bg-canvas-muted px-2xl py-4xl sm:px-3xl sm:py-7xl md:px-4xl'
});

export const Wrapper = createComponent('div', {
  className:
    'flex w-full max-w-[1272px] flex-col justify-between gap-2xl sm:flex-row'
});

export const AccordionWrapper = createComponent('div', {
  className: 'flex max-w-[730px] flex-col gap-2xl'
});

export const HeadlineContainer = createComponent('div', {
  className:
    'align-start flex shrink-0 flex-col gap-lg sm:w-[219px] md:w-[384px] md:gap-xl lg:w-[408px]'
});

export const Headline = createComponent('h2', {
  className: 'text-text-strong t-heading-2xl'
});

export const HeadlineText = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const InfoWrapper = createComponent('div', {
  className: 'grid gap-xl pb-xl'
});

export const InfoSubheading = createComponent('div', {
  className: 'text-text-strong t-strong-sm'
});

export const InfoText = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
